import CardCommon from '@op/components/CardCommon';
import React, { useMemo, useState } from 'react';
import { IAddedKeywordProps } from '../../../type';
import { Location, useLocation } from 'umi';
import { LanguageType } from '@op/types/common';
import { RisingKeywordItem } from '@op/components/Snippets/KeywordItem';
import useLanguage from '@op/hooks/useLanguage';
import { languageSelectOptions } from '@op/components/FilterBoxCommon/constant';
import { DBO_TM } from '@op/utils/format';
import { useRealtimeRisingKeyword } from '../../../hook';
import './index.scss';
import BubbleCommon, { realtimeOptionsKeywordDaily, realtimeOptionsKeywordHourly } from '@op/components/BubbleCommon';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import SvgIcon from '@home/components/SvgIcon';

export default function AddedKeyword({ deadline, filter }: IAddedKeywordProps) {
  const location: Location = useLocation();
  const query = location?.query || {};
  const { formatOptionsMessage, formatMessage } = useLanguage();
  const [language, setLanguage] = useState<LanguageType>('origin');
  const isToday = useMemo(() => DBO_TM.isToday(filter), [filter]);

  const filterParams = useMemo(() => {
    if (isToday) {
      return {
        ...filter,
        date_type: 'hourly',
        need_many_hour_ago: isToday,
        many_hour_ago: deadline === 'last_hour' ? 1 : 0
      };
    }
    return {
      ...filter,
      date_type: 'hourly',
      need_many_hour_ago: false,
    };
  }, [deadline, isToday, filter]);

  const { data, loading, text, keywordClick, formatDate } =
    useRealtimeRisingKeyword({
      filter: filterParams,
      extraData: query,
    });

  return (
    <CardCommon
      loading={loading}
      loadingHeight={35}
      emptyHeight={35}
      hasEmptyImg={false}
      hasEmptyTitle={false}
      dropdowns={data?.list?.length !== 0 ? formatOptionsMessage(languageSelectOptions) : undefined}
      dropdownFooter={
        <div style={{ textAlign: 'left', maxWidth: 204 }}>
          {formatMessage({
            id: 'From GPT-Translator. Powered by DataBrain NLP Team',
          })}
        </div>
      }
      defaultDropDown={language}
      handleDropdownOnChange={({ value }: { value: any }) => {
        setLanguage(value);
        buriedBtnPoint('RO_Keyword_Language', value);
      }}
      empty={data?.list?.length === 0}
      title={
        <div className='dbo-realtime-added-keyword-title'>
          <BubbleCommon
            tipsMap={isToday ? realtimeOptionsKeywordHourly : realtimeOptionsKeywordDaily}
          >
            <span className='title-text'>
              {formatMessage({ id: isToday ? 'Hourly Rising Keywords' : 'Rising Keywords-1' })}
            </span>
          </BubbleCommon>
        </div>
      }
      className='dbo-realtime-added-keyword'
      otherSelectProps={{
        button: (option: { text: string }) => (
          <div className="dbo-select-button">
            <SvgIcon type="translate" className="dbo-select-button-icon" />
            <div className="tea-text-overflow">{option?.text}</div>
          </div>
        ),
      }}
    >
      {(data?.list || []).map((item, index) => {
        return (
          <RisingKeywordItem
            item={item}
            key={index}
            language={language}
            onClick={() => {
              keywordClick(item);
            }}
            formatDate={formatDate}
            text={text}
          ></RisingKeywordItem>
        );
      })}
    </CardCommon>
  );
}
